import Image from 'next/image'
import { externalImageLoader } from '../../../../utilities/externalImageLoader'
import { Listicle } from '../../../../models/types/Listicle.type'

type ListicleCardProps = {
  listicle: Listicle
}

export const ListicleCard = ({ listicle }: ListicleCardProps) => {
  const { imgSrc, title, description, url, alt } = listicle

  return (
    <>
      <a href={url} className='item-link'>
        <div className='card'>
          <div className='preview-image-wrapper'>
            <Image
              aria-hidden={true}
              className='preview-image'
              src={imgSrc}
              loader={externalImageLoader}
              alt={alt ?? title}
              unoptimized
              style={{ objectFit: 'cover' }}
              fill
              sizes='500px'
            />
          </div>
          <article className='preview'>
            <h3 className='preview-title'>{title}</h3>
            <p className='preview-text'>{description}</p>
            <p className='read-more'>Read more</p>
          </article>
        </div>
      </a>
      <style jsx>{`
        .item-link:hover .read-more,
        .item-link:focus-visible .read-more {
          text-decoration: underline;
        }

        .item-link:hover .preview-image-wrapper,
        .item-link:focus-visible .preview-image-wrapper {
          opacity: 0.8;
          transition: opacity 0.2s ease-in-out;
          -moz-transition: opacity 0.2s ease-in-out;
          -webkit-transition: opacity 0.2s ease-in-out;
        }

        .item-link {
          text-decoration: none;
          width: 100%;
        }

        .item-link:focus-visible {
          outline: none;
        }

        .card {
          scroll-snap-align: start;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          width: 100%;
          height: 498px;
          background: linear-gradient(0deg, #ffffff, #ffffff), #262626;
          border-radius: 8px;
        }

        .preview {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding: 24px;
          width: 100%;
        }

        .preview-title {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          min-height: 64px;
          font-weight: 700;
          font-size: 24px;
          line-height: 32px;
          margin-top: 0;
        }

        .preview-image-wrapper {
          width: 100%;
          min-height: 276px;
          max-height: 276px;
          object-fit: cover;
          border-radius: 8px 8px 0px 0px;
          overflow: hidden;
          position: relative;
          opacity: 1;
          transition: opacity 0.2s ease-in-out;
          -moz-transition: opacity 0.2s ease-in-out;
          -webkit-transition: opacity 0.2s ease-in-out;
        }

        .preview-text {
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          min-height: 72px;
        }

        .read-more {
          font-weight: 700;
          text-align: center;
          margin-top: auto;
        }

        h4,
        p {
          color: #1f1f1f;
        }

        h4 {
          font-weight: 700;
          font-size: 24px;
          line-height: 32px;
          margin-top: 0;
        }

        p {
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
        }
      `}</style>
    </>
  )
}
